import React from 'react';
import BrandsDropdown from '../brand/BrandsDropdown';
import SidebarItem from './SidebarItem';
import SidebarSessions from './SidebarSessions';

interface IProps {
    store: any;
}

const Sidebar = ({ store }: IProps) => {
    return (
        <div className="tw-bg-gray-100 tw-w-[244px] tw-h-full tw-z-100 tw-py-5 tw-px-4 tw-shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]">
            <BrandsDropdown />
            <div className="tw-mt-4 tw-w-full tw-flex tw-flex-col tw-gap-y-1">
                <SidebarItem icon="house" text="Home" urlText="/" />
                <SidebarItem icon="images" text="Plans Collection" urlText="/plans" />
                <SidebarItem icon="image-square" text="Editor" urlText="/editor" />
                <SidebarItem icon="layout" text="Projects" urlText="/projects" />
            </div>
            <hr className="tw-border-gray-700 tw-my-3 tw-w-full tw-border" />
            <SidebarSessions store={store} />
            <hr className="tw-border-gray-700 tw-my-3 tw-w-full tw-border" />
            {/* <SidebarItem icon="timer" text="Scheduler" urlText="/social" /> */}
        </div>
    );
};

export default Sidebar;
